<!-- Solid, not see-through: the photos scroll under it -->
<header class="sticky top-0 z-20 bg-background-light px-3 pt-3 pb-2">
  <nav class="mx-auto flex h-14 max-w-5xl items-center justify-between gap-3 rounded-xl bg-primary px-4 shadow-card-elevated">
    <a routerLink="/" class="flex-shrink-0 rounded focus-visible:outline focus-visible:outline-2 focus-visible:outline-accent">
      <img ngSrc="assets/images/logo_transparent_rectangle.png" alt="corpers.ng logo" class="w-28 -mb-1" width="410" height="65" priority>
    </a>
    <a *ngIf="callerService.isLoggedIn; else loggedOut" [routerLink]="backLink"
      class="inline-flex min-h-10 items-center gap-1 rounded-lg px-3 text-sm font-medium text-white hover:bg-white/10 focus-visible:outline focus-visible:outline-2 focus-visible:outline-accent">
      <mat-icon class="!size-5 !text-xl !leading-5" aria-hidden="true">arrow_back</mat-icon> {{ backLabel }}
    </a>
    <ng-template #loggedOut>
      <div class="flex gap-2">
        <a routerLink="/login" [queryParams]="returnHere"
          class="inline-flex min-h-10 items-center rounded-lg border border-white/30 px-3 text-sm font-medium text-white hover:bg-white/10 focus-visible:outline focus-visible:outline-2 focus-visible:outline-accent">Login</a>
        <a routerLink="/signup" [queryParams]="returnHere"
          class="btn-accent inline-flex min-h-10 items-center !px-3 !py-0 text-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent">Sign up</a>
      </div>
    </ng-template>
  </nav>
</header>
